import Vue from 'vue'
import App from './App'
import router from './router'
import 'amfe-flexible'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)

// 引入store
import store from './store'

// 引入公用组件
import alertJs from '@/components/alert/alert.js'
Vue.prototype.$alert = alertJs.alertModal
Vue.prototype.$confirm = alertJs.confirmModal
import loadingJs from '@/components/loading/loading'
Vue.prototype.$loading = loadingJs.loadingModal
Vue.prototype.$loadingClose = loadingJs.loadingCloseModal
import headers from '@/components/headers/headers'
Vue.component('headers', headers)
import footers from '@/components/footers/footers'
Vue.component('footers', footers)
import navs from '@/components/navs/navs'
Vue.component('navs', navs)
import pages from '@/components/pages/pages'
Vue.component('pages', pages)
import shopcars from '@/components/shopcars/shopcars'
Vue.component('shopcars', shopcars)
import mynavs from '@/components/mynavs/mynavs'
Vue.component('mynavs', mynavs)
import floats from '@/components/floats/floats'
Vue.component('floats', floats)

// 导入所有接口
import request from '@/api/request'
Vue.prototype.$ajax = request

// 公用方法
import comment from '@/assets/js/common'
Vue.prototype.$api = comment

// 富文本iframe
Vue.prototype.$richIframe = comment.richIframe
Vue.prototype.$richIframeInit = comment.richIframeInit

Vue.config.productionTip = false

export default new Vue({
	el: '#app',
	router,
	store,
	components: { App },
	template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js